import { useState } from "react";
import Modal from "react-responsive-modal";

export default function TemplateOption(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);
    const [selectedOption, setSelectedOption] = useState("headerOnly");
    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }
    return (
        <div className="ws-6">

            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 pull-right bgTransparent' }} >
                <div className="box">

                    <div className="box-header-main well">
                        <h2><i className="fa fa-question-circle"></i> Confirm ?</h2>
                    </div>

                    <div className="box-content test">
                        <span>The ingested Template have which follow order ?</span>

                        <div className="mtl">
                            <label className="ws-12">
                                <input type="radio" name="templateOption" value="headerOnly" checked={selectedOption === "headerOnly"} onChange={(e) => setSelectedOption(e.target.value)} />
                                Template Header Only
                            </label>
                            <label className="ws-12">
                                <input type="radio" name="templateOption" value="headerMapping" checked={selectedOption === "headerMapping"} onChange={(e) => setSelectedOption(e.target.value)} />
                                Template Header + Mapping
                            </label>
                            <label className="ws-12">
                                <input type="radio" name="templateOption" value="headerMappingData" checked={selectedOption === "headerMappingData"} onChange={(e) => setSelectedOption(e.target.value)} />
                                Template Header + Mapping + Data
                            </label>
                            <label className="ws-12">
                                <input type="radio" name="templateOption" value="headerMappingData" checked={selectedOption === "headerData"} onChange={(e) => setSelectedOption(e.target.value)} />
                                Template Header +  Data
                            </label>
                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn primary" onClick={() => returnValue(selectedOption)}> Choose</button>
                    </div>

                </div>
            </Modal>

        </div>
    )
}